import React from "react";
import Store from "../../content/Store";
import Contentify from "../../content/Contentify";
import styles from "./../../../src/assets/css/modules/makeAClaim/prompt-message-for-cashbenefit.css";

export const PromptMessageForCashBenefit = ({ content }) => {
  return (
    <p className={styles.promptMessage + " input-tooltip"}>
      {content.notExistingClaim}
    </p>
  );
};

PromptMessageForCashBenefit.content = Store.ClaimBackChemoOrRadiotherapy;

export default Contentify(PromptMessageForCashBenefit);
